import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWelcome2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 159,
	height: 153,
	viewBox: "0 0 159 153",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_ddii_11278_49471)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 83.5,
				cy: 80,
				r: 61.3928,
				fill: "#F7F8FA"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M104.404 93.0656C103.731 92.4017 102.924 91.8706 101.982 91.6051V78.0617H104.269V74.4768H101.982V71.6884H104.269V68.1035H101.982V65.979H98.349V68.1035H96.0615V71.6884H98.349V74.4768H96.0615V78.0617H98.349V83.24H94.4467C93.9085 80.0534 91.7556 77.5306 88.1225 75.6717C88.3917 75.4062 88.9299 75.1406 90.141 75.1406L92.0248 75.2734V65.979H78.7036L78.1654 66.9085C77.8962 67.3068 77.4925 67.7051 76.8197 68.5018C74.5323 70.4935 73.1867 73.149 73.0521 76.3356V76.4684C73.1867 78.0617 73.4558 79.6552 74.1286 80.85C73.7249 84.7007 71.7065 87.3562 68.0735 88.5512C66.997 88.8166 66.0551 89.0823 65.2478 89.6134C63.7676 88.9495 63.4985 87.8873 63.4985 87.0905C63.4985 86.1612 63.7676 84.9661 66.3242 84.1696C69.5536 83.1072 71.3029 80.7174 71.1683 77.2651V74.7423C72.5139 73.5473 73.3212 72.2196 73.4558 70.6262C73.5903 68.7674 72.6484 66.7757 70.6301 64.9168L69.6882 63.8546L68.4771 65.0496C66.4588 66.9085 65.5169 68.9001 65.5169 70.759C65.6514 72.2196 66.4588 73.6801 67.8044 74.8751V77.3978C67.8044 79.3895 67.1316 80.3189 65.3823 80.9828C60.9419 82.4435 60 85.2318 60 87.3562C60 88.684 60.5382 90.6756 62.2875 92.1362C60.9419 93.5967 60.2691 95.5884 60.1346 97.8456V105.281H82.3365V105.016C82.3365 103.157 80.8565 101.696 78.9726 101.696H75.3395C76.2815 99.7044 78.0308 98.2439 80.4528 97.4472C82.3365 97.1817 83.9513 96.7833 85.4314 96.2522V105.281H93.6395V105.016C93.6395 103.157 92.1593 101.696 90.2756 101.696H89.0645V94.5261C89.1991 94.3934 89.3336 94.2606 89.4681 94.1278C92.1593 92.0034 93.7741 89.4806 94.1777 86.8251H98.0798V91.7378C97.138 92.0034 96.3306 92.5345 95.6578 93.1984C94.4467 94.3934 93.9085 95.7211 93.9085 97.3145C93.9085 98.9078 94.4467 100.368 95.6578 101.43C96.3306 102.094 97.138 102.626 98.0798 102.891V105.547H101.713V102.891C102.655 102.626 103.462 102.094 104.135 101.43C105.346 100.235 105.884 98.9078 105.884 97.3145C106.153 95.5884 105.615 94.2606 104.404 93.0656ZM102.52 97.1817C102.52 97.8456 102.251 98.3767 101.848 98.775C101.444 99.1733 100.906 99.4389 100.233 99.4389C99.56 99.4389 99.0218 99.1733 98.6181 98.775C98.2144 98.3767 97.9452 97.7128 97.9452 97.1817C97.9452 96.5178 98.2144 95.9867 98.6181 95.5884C99.0218 95.19 99.56 94.9245 100.233 94.9245C100.906 94.9245 101.444 95.19 101.848 95.5884C102.386 96.1195 102.52 96.5178 102.52 97.1817ZM90.141 87.489C89.0645 85.3646 86.9115 83.7711 83.2785 82.7089H83.0094C80.3182 82.1778 78.569 81.2484 77.6271 79.655C77.0888 78.7256 76.8197 77.6634 76.6851 76.4684C76.6851 75.4062 76.9543 74.6095 77.2234 73.8129C78.569 76.4684 81.3947 77.929 85.2968 78.4601C88.7953 79.9206 90.6792 81.7795 90.8138 84.3022C90.8138 84.5679 90.8138 84.8333 90.8138 85.099C90.8138 86.1612 90.5446 87.0905 90.141 88.0201C90.2756 87.7544 90.2756 87.6218 90.141 87.489ZM64.0367 101.563V97.8456C64.1713 96.2522 64.575 94.9245 65.5169 93.995C67.8044 94.2606 69.419 95.0573 70.361 96.2522C71.4374 97.4472 71.8411 99.3061 71.7065 101.563H64.0367ZM73.1867 93.995C72.3793 93.0656 71.4374 92.2689 70.361 91.7378C72.5139 90.8084 74.3977 89.4806 75.6087 87.7544C76.4161 86.6922 76.9543 85.4972 77.358 84.1696C78.7036 85.099 80.4528 85.7629 82.4711 86.1612C84.8932 86.9579 86.3733 87.8873 87.0461 89.0823C87.4499 89.7462 87.4499 90.6756 87.1807 91.6051C87.0461 91.7378 86.9115 91.7378 86.9115 91.8706L86.777 92.0034C85.4314 92.8 83.2785 93.4639 80.3182 93.8623H79.78C77.7616 94.5261 76.0123 95.5884 74.8013 96.7833C74.3977 95.7211 73.8594 94.7917 73.1867 93.995ZM86.2388 72.6179C85.566 73.149 85.0278 73.8129 84.624 74.6095C83.2785 74.344 82.2021 73.8129 81.5293 73.2818C80.7219 72.6179 80.3182 71.6884 80.0491 70.4935C80.3182 70.2279 80.5873 69.8296 80.8565 69.564H88.5263V71.6884C87.7189 71.8212 86.9115 72.2196 86.2388 72.6179ZM69.6882 68.2363L69.9573 68.5018C70.4955 69.2985 70.7646 69.9623 70.7646 70.6262C70.7646 71.1573 70.4955 71.6884 69.9573 72.2196L69.8227 72.3523L69.6882 72.2196C69.1499 71.6884 68.8808 71.1573 68.8808 70.6262C68.8808 69.9623 69.1499 69.2985 69.6882 68.5018V68.2363Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.7373 64.6512L92.9667 58.809L89.8718 57.0829L87.5843 61.0662H82.7403L80.4528 57.0829L77.2234 58.809L80.5873 64.6512H89.7373Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.1692 54L82.8864 56.2539L85.1705 58.5066L87.4534 56.2526L85.1692 54Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_ddii_11278_49471",
			x: .107178,
			y: .607178,
			width: 157.986,
			height: 151.986,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: -14,
					dy: -10
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_11278_49471"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 1,
					operator: "erode",
					in: "SourceAlpha",
					result: "effect2_dropShadow_11278_49471"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 6,
					dy: 4
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.1 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_11278_49471",
					result: "effect2_dropShadow_11278_49471"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_11278_49471",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: -5,
					dy: -2
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect3_innerShadow_11278_49471"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 7,
					dy: 7
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect3_innerShadow_11278_49471",
					result: "effect4_innerShadow_11278_49471"
				})
			]
		}) })
	]
});
export default SvgWelcome2;
